import { createContext } from "react";
import { LanguageContextProps } from "../../Interface/context/Language/interface";

const LanguageContext = createContext<LanguageContextProps | null>(null);

export default LanguageContext;
